import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import DormRoomStoragePage from '@/v2/components/pages/public-pages/dorm-room-storage-page'
import { metaImages, ogImages } from '@/v2/constants/pages/public-pages/dorm-room-storage-page'

interface DormRoomStoragePageProps {}

const Page: React.FC<DormRoomStoragePageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.dorm_room_storage.title ?? ''}
        keywords={META_CONTENTS.dorm_room_storage?.keywords ?? ''}
        description={META_CONTENTS.dorm_room_storage?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />
      <DormRoomStoragePage />
    </>
  )
}

export default Page
